import { Button } from '@mui/material'

import { cleverAuthURL } from '../../hooks/useClever'

function CleverButton({ sx = {}, ...props }) {
  return (
    <Button
      fullWidth
      color="secondary"
      href={cleverAuthURL}
      startIcon={<CleverIcon />}
      sx={{ textTransform: 'none', height: 44, fontSize: 16, fontWeight: 600, lineHeight: '24px', ...sx }}
      variant="outlined"
      {...props}
    >
      Sign in with Clever
    </Button>
  )
}

export default CleverButton

function CleverIcon(props) {
  return (
    <svg fill="none" height={25} viewBox="0 0 24 25" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_300_732)">
        <path
          d="M16.6711 15.5488L17.2031 12.0801H13.875V9.83008C13.875 8.88109 14.34 7.95508 15.8306 7.95508H17.3438V5.00195C17.3438 5.00195 15.9705 4.76758 14.6576 4.76758C11.9166 4.76758 10.125 6.42883 10.125 9.43633V12.0801H7.07812V15.5488H10.125V23.9343C11.3674 24.1287 12.6326 24.1287 13.875 23.9343V15.5488H16.6711Z"
          fill="white"
        />
        <g clipPath="url(#clip1_300_732)">
          <path
            d="M21 19.5866C20.0851 20.6135 19.043 21.4751 17.8231 22.11C16.0128 23.0516 14.062 23.3459 12.0535 23.2436C8.9895 23.0871 6.3692 21.9126 4.44244 19.4959C1.82837 16.2185 1.34468 12.5117 2.83755 8.65551C4.31974 4.82866 7.2868 2.69295 11.3297 2.19414C14.6987 1.77802 17.8178 2.47155 20.4149 4.83577C20.9066 5.28301 20.9093 5.28123 20.4869 5.76759C19.7481 6.61672 18.9994 7.45784 18.2765 8.32031C18.0445 8.59772 17.8916 8.62706 17.607 8.37721C16.5481 7.44628 15.3691 6.72875 13.9536 6.46823C10.6789 5.86451 7.72603 7.81083 7.05117 11.0829C6.56482 13.4426 7.02183 15.6041 8.74498 17.37C10.5144 19.1829 13.4565 19.5528 15.8234 18.2627C16.5312 17.8768 17.1553 17.3353 17.8071 16.8498C17.9902 16.7129 18.1174 16.6053 18.3263 16.8196C19.1737 17.69 20.0335 18.5472 20.8879 19.4114C20.928 19.4514 20.9511 19.5092 21 19.5884V19.5866Z"
            fill="#456CF5"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_300_732">
          <rect fill="white" height={24} transform="translate(0 0.0800781)" width={24} />
        </clipPath>
        <clipPath id="clip1_300_732">
          <rect fill="white" height={21.1828} transform="translate(2 2.08008)" width={19} />
        </clipPath>
      </defs>
    </svg>
  )
}
